<header
    class="m-header"
    #nav
>
    <div class="m-header-navbar">
        <div class="m-header-navbar-left">
            <a
                class="m-org"
                id="navHomeAnchor"
                [routerLink]="['/']"
            >
                <img
                    class="m-org__logo"
                    [attr.src]="organization?.logoUrl ? organization.logoUrl : '/assets/img/brand-icon.png'"
                    alt="logo"
                />

                @if (isDesktop) {
                    <div class="m-org__info">
                        @if (isAuthenticated !== null && isAuthenticated === true) {
                            <span class="m-org__name"> {{ organization?.name }}</span>
                        }
                        <span
                            class="m-org__product"
                            [attr.data-env-label]="envLabel"
                            >{{ "poweredBy" | translate: { productName: websiteService.getProductName() } }}</span
                        >
                    </div>
                }
            </a>
        </div>

        <div class="m-header-navbar-right">
            <nav
                class="m-nav-primary"
                #navbar
            >
                <ul class="m-nav-list">
                    <!-- currentUser means we're authenticated, user means we know who we are.
                        After login we know we're authenticated, but don't know yet who we are for a little while -->
                    @if (isAuthorized) {
                        <ng-template
                            [ngTemplateOutlet]="loggedInTemplate"
                            [ngTemplateOutletContext]="{ $implicit: availableNavLinks }"
                        >
                        </ng-template>
                        @if (isMobile) {
                            <ng-template
                                [ngTemplateOutlet]="logoutDropdown"
                                [ngTemplateOutletContext]="{ cssClass: 'dropdown-mobile-only' }"
                            ></ng-template>
                        }
                    }

                    @if (isAuthenticated !== null && isAuthenticated === false) {
                        <ng-template [ngTemplateOutlet]="notLoggedInTemplate"></ng-template>
                    }

                    <ng-template
                        #loggedInTemplate
                        let-navLinks
                    >
                        @for (link of navLinks; track link.title) {
                            <li class="m-nav-list-item">
                                <a
                                    class="m-nav-link"
                                    [attr.data-testid]="'nav-' + link.screenName"
                                    [id]="'nav' + link.screenName + 'MenuAnchor'"
                                    [ngClass]="{ 'is-active': isActive(link) }"
                                    [routerLink]="[link.route]"
                                    (click)="closeMenus()"
                                >
                                    <app-svg-icon [icon]="link.icon"></app-svg-icon>
                                    <span> {{ link.title | translate }}</span>
                                </a>
                            </li>
                        }
                    </ng-template>

                    <ng-template #notLoggedInTemplate>
                        <li
                            class="m-nav-list-item"
                            [routerLinkActive]="['link-active']"
                        >
                            <a
                                class="m-nav-link"
                                id="navMenuAboutAnchor"
                                [routerLink]="['/about']"
                                (click)="closeMenus()"
                            >
                                <app-svg-icon icon="info"></app-svg-icon>
                                {{ "about.title" | translate: { productName: websiteService.getProductName() } }}
                            </a>
                        </li>

                        <li class="m-nav-list-item">
                            <a
                                class="m-nav-link"
                                id="navMenuLogin"
                                (click)="closeMenus(); login()"
                            >
                                <app-svg-icon icon="profile"></app-svg-icon>
                                {{ "general.login" | translate }}
                            </a>
                        </li>
                    </ng-template>
                </ul>
            </nav>

            <ng-template
                #logoutDropdown
                let-cssClass="cssClass"
            >
                <div
                    class="nav-dropdown m-dropdown m-account-dropdown"
                    id="navMenuDropdown"
                    #navdropdown
                    [ngClass]="cssClass"
                >
                    <a
                        class="m-dropdown-toggle"
                        (click)="toggleDropdown()"
                        data-testid="nav-menu-toggle"
                    >
                        <!-- <app-svg-icon icon="profile">
                            </app-svg-icon> -->
                        <span class="m-account-item has-background">
                            {{ authorizationInfo && authorizationInfo.user.firstName.charAt(0) | uppercase
                            }}{{ authorizationInfo && authorizationInfo.user.lastName.charAt(0) | uppercase }}
                        </span>
                    </a>

                    <ul class="m-dropdown-menu">
                        @if (!isDesktop) {
                            <li class="m-text-white">
                                <h3
                                    class="m-text-white"
                                    style="padding: 10px"
                                >
                                    {{ authorizationInfo && authorizationInfo.user.email }}
                                </h3>
                            </li>
                        }
                        @if (showImpersonationDropdown) {
                            <li>
                                <m-select-control
                                    class="impersonate-dropdown"
                                    id="navMenuImpersonateOrganization"
                                    #impersonateOrganizationDropdown
                                    [filter]="true"
                                    [ngModel]="impersonationService.organization"
                                    [options]="impersonationOrganizations"
                                    [resetFilterOnHide]="true"
                                    [showClear]="true"
                                    [style]="{ width: '100%' }"
                                    (valueChanged)="setImpersonation($event)"
                                    appearance="plain"
                                    appendTo="body"
                                    data-testid="impersonate-organization"
                                    dataKey="id"
                                    placeholder="{{ 'admin.impersonate' | translate }}"
                                >
                                </m-select-control>
                            </li>
                        }
                        @if (showRoleImpersonationDropdown) {
                            <li>
                                <m-select-control
                                    id="navMenuImpersonateRole"
                                    #impersonateRoleDropdown
                                    [filter]="true"
                                    [ngModel]="impersonationService.role"
                                    [options]="roles"
                                    [resetFilterOnHide]="true"
                                    [showClear]="true"
                                    [style]="{ width: '100%' }"
                                    (valueChanged)="setRoleImpersonation($event)"
                                    appearance="plain"
                                    appendTo="body"
                                    data-testid="impersonate-role"
                                    placeholder="{{ 'admin.impersonateRole' | translate }}"
                                ></m-select-control>
                            </li>
                        }
                        @if (showMockProgress) {
                            <li>
                                <a
                                    id="navMenuMockProgress"
                                    (click)="mockProgress()"
                                    >Mock progress</a
                                >
                            </li>
                        }
                        <li>
                            <a
                                id="navMenuAboutAnchor"
                                [routerLink]="['/about']"
                                [routerLinkActive]="['link-active']"
                                (click)="closeMenus()"
                            >
                                {{ "about.title" | translate: { productName: websiteService.getProductName() } }}
                            </a>
                        </li>
                        <li class="language-picker">
                            <ng-template
                                #languageTemplate
                                let-language
                            >
                                <div class="flex align-center">
                                    <app-svg-icon
                                        [icon]="language"
                                        file="assets/flag-icons.svg"
                                        fill="black"
                                        style="width: 32px"
                                    />
                                    {{ language | translateEnum: "language" }}
                                </div>
                            </ng-template>

                            @if (languages) {
                                <m-select-control
                                    id="navMenuLanguage"
                                    #languageDropdown
                                    [ngModel]="currentLanguage"
                                    [options]="languages"
                                    [style]="{ width: '100%' }"
                                    (ngModelChange)="setLanguage($event)"
                                    appearance="plain"
                                    appendTo="body"
                                >
                                    <ng-template
                                        let-language
                                        mSelectSelectedItem
                                    >
                                        <ng-template
                                            [ngTemplateOutlet]="languageTemplate"
                                            [ngTemplateOutletContext]="{ $implicit: language?.value }"
                                        >
                                        </ng-template>
                                    </ng-template>
                                    <ng-template
                                        let-language
                                        mSelectItem
                                    >
                                        <div>
                                            <ng-template
                                                [ngTemplateOutlet]="languageTemplate"
                                                [ngTemplateOutletContext]="{ $implicit: language?.value }"
                                            >
                                            </ng-template>
                                        </div>
                                    </ng-template>
                                </m-select-control>
                            }
                        </li>
                        <li>
                            <a
                                id="navMenuLogout"
                                (click)="closeMenus(); logout()"
                            >
                                {{ "general.logout" | translate }}
                            </a>
                        </li>
                    </ul>
                </div>
            </ng-template>

            @if (isAuthorized) {
                <div class="m-account">
                    @if (authorizationInfo && connectivityService.missingConnection) {
                        <div class="m-nav-list-item">
                            <span class="m-account-item blink">
                                <app-svg-icon
                                    [ngStyle]="{ fill: '#FF0000' }"
                                    [tooltip]="'general.connectionProblem' | translate"
                                    [tooltipPosition]="'bottom'"
                                    icon="circle-exclamation"
                                />
                            </span>
                        </div>
                    }

                    @if (authorizationInfo) {
                        <div class="m-nav-list-item">
                            <a
                                class="m-nav-link"
                                id="navHelpAnchor"
                                routerLink="/documentation/viewer/introduction"
                                title="{{ 'documentation.link' | translate }}"
                            >
                                <span class="m-account-item">
                                    <app-svg-icon
                                        [ngStyle]="{ fill: '#173232' }"
                                        icon="circle-question"
                                    />
                                </span>
                            </a>
                        </div>
                    }

                    @if (authorizationInfo) {
                        <div class="m-nav-list-item">
                            <app-notification-bubble></app-notification-bubble>
                        </div>
                    }

                    <ng-container *ngTemplateOutlet="logoutDropdown"></ng-container>
                </div>
            }

            @if (isAuthenticated !== null && isAuthenticated === false) {
                <div class="m-language">
                    <div class="m-language-dropdown">
                        <ng-template
                            #languageTemplate
                            let-language
                        >
                            <app-svg-icon
                                [icon]="language"
                                [ngStyle]="{ fill: '#000' }"
                                file="assets/flag-icons.svg"
                            ></app-svg-icon>
                            {{ language | translateEnum: "language" }}
                        </ng-template>

                        @if (languages) {
                            <m-select-control
                                id="navMenuLanguage"
                                #languageDropdown
                                [ngModel]="translate.currentLang"
                                [options]="languages"
                                (ngModelChange)="setLanguage($event)"
                                appearance="plain"
                            >
                                <ng-template
                                    let-language
                                    mSelectSelectedItem
                                >
                                    <ng-template
                                        [ngTemplateOutlet]="languageTemplate"
                                        [ngTemplateOutletContext]="{ $implicit: language?.value }"
                                    >
                                    </ng-template>
                                </ng-template>

                                <ng-template
                                    let-language
                                    mSelectItem
                                >
                                    <div>
                                        <ng-template
                                            [ngTemplateOutlet]="languageTemplate"
                                            [ngTemplateOutletContext]="{ $implicit: language.value }"
                                        >
                                        </ng-template>
                                    </div>
                                </ng-template>
                            </m-select-control>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
</header>
